// ===== Interfaces =====

import {
    IAnnotationItem,
}                           from '../interfaces';

// ** IMPORTANT **: Keep in sync with functions/src/index.ts
const getAnnotationFreshnessTimestamp = (
    annotationItem: IAnnotationItem,
    latestUpdatedAt?: number,
): number => {
    let freshness = annotationItem.published || 0;
    if (latestUpdatedAt != null) {
        freshness = Math.max(freshness, latestUpdatedAt);
    }
    if (annotationItem.history.length > 0) {
        freshness = Math.max(
            freshness,
            ...annotationItem.history.map((historyItem) => historyItem.timestamp || 0),
        );
    }
    if (annotationItem.deleted.timestamp != null) {
        freshness = Math.max(freshness, annotationItem.deleted.timestamp);
    }
    return freshness;
};

export default getAnnotationFreshnessTimestamp;
